/**
 * ActionCard editors — the product's own controls, inside the card.
 *
 * A proposal card is not a summary of what will be created — it IS the
 * create form, prefilled from the model's proposal and editable
 * before approval. Every field here writes into the `overrides` the parent
 * sends on Approve; the server re-validates them the way the product's own
 * create route would (services/ask/actions/proposals.js mergeOverrides).
 */
import React from "react";
import { trodoAnalyticsTheme as theme } from "features/analytics/studio/theme";

const fieldLabelStyle = { fontSize: 11, color: theme.textSecondary, marginBottom: 4, display: "block" };
const inputStyle = {
  width: "100%", fontSize: 13, borderRadius: 8, border: `1px solid ${theme.border}`,
  padding: "6px 8px", background: "transparent", color: theme.textPrimary, fontFamily: "inherit",
};

function Field({ label, children }) {
  return (
    <div style={{ display: "grid", gap: 3, marginTop: 8 }}>
      <span style={fieldLabelStyle}>{label}</span>
      {children}
    </div>
  );
}

const CRON_PRESETS = [
  { label: "Every day, 9am", value: "0 9 * * *" },
  { label: "Weekdays, 9am", value: "0 9 * * 1-5" },
  { label: "Mondays, 9am", value: "0 9 * * 1" },
  { label: "Every hour", value: "0 * * * *" },
];
const EFFORTS = ["low", "medium", "high", "max"];

export function RoutineEditor({ payload, onChange }) {
  const cronOk = /^(\S+\s+){4}\S+$/.test(String(payload?.cron || "").trim());
  return (
    <div style={{ marginTop: 4 }}>
      <Field label="Question, asked on this schedule">
        <textarea
          value={payload?.objective || ""} onChange={(e) => onChange({ objective: e.target.value })}
          rows={2} style={{ ...inputStyle, resize: "vertical" }}
        />
      </Field>
      <Field label="Schedule (cron)">
        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
          <input
            value={payload?.cron || ""} onChange={(e) => onChange({ cron: e.target.value })}
            style={{ ...inputStyle, width: 140, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
          />
          <select
            value="" onChange={(e) => e.target.value && onChange({ cron: e.target.value })}
            style={{ ...inputStyle, width: "auto", padding: "5px 6px" }}
          >
            <option value="">presets…</option>
            {CRON_PRESETS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
        </div>
        {!cronOk && <div style={{ marginTop: 4, fontSize: 11, color: "var(--feedback-error)" }}>Needs five fields, e.g. "0 9 * * 1".</div>}
      </Field>
      <Field label="Research depth">
        <select value={payload?.effort || "medium"} onChange={(e) => onChange({ effort: e.target.value })} style={{ ...inputStyle, width: "auto", padding: "5px 8px" }}>
          {EFFORTS.map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
      </Field>
    </div>
  );
}
